module.exports = __webpack_public_path__ + "static/img/04.1cb00fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/04.jpg
// module id = GOpJ
// module chunks = 0